import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { useMemo } from 'react';

import { BlogProducer } from './BlogProducer';

import type VideoCreatorStore from '@src/stores/VideoCreatorStore';

/**
 * DI hook for BlogProducer. Replaces inline `new BlogProducer(...)` inside
 * view components per CLAUDE.md's "Components \u2014 useXService() hooks for
 * DI, never `new Service()`" rule.
 *
 * Note: BlogProducer still lives under components/ and mutates the
 * videoCreator store. Moving/purifying it is a separate follow-up; this
 * hook only fixes the direct-instantiation violation.
 */
export function useBlogProducer(type: 'blog' | 'socialPost'): BlogProducer {
  const videoCreator = useVideoCreatorStore();
  const datoClientStore = useDatoClient();
  return useMemo(
    () =>
      new BlogProducer(
        type,
        videoCreator as VideoCreatorStore,
        datoClientStore.assetRepository,
        datoClientStore.storyRepository,
      ),
    [
      type,
      videoCreator,
      datoClientStore.assetRepository,
      datoClientStore.storyRepository,
    ],
  );
}
